import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from './modal.component';

export interface OpenModal {
    titleLabel?: string;
    buttonLabel?: string;
    content: string;
}

const DEFAULT_OPTIONS: Partial<OpenModal> = {
    buttonLabel: 'misc.Got it'
};

@Injectable()
export class ModalService {
    constructor(private ngbModal: NgbModal) {}

    public openModal(openModalOptions: OpenModal) {
        const options = { ...openModalOptions, ...DEFAULT_OPTIONS };
        const modal = this.ngbModal.open(ModalComponent, {
            windowClass: 'ngb-modal modal-scroll field-widget-tinymce',
            size: 'lg',
            backdrop: 'static'
        });
        const componentInstance = modal.componentInstance as ModalComponent;

        componentInstance.titleLabel = options.titleLabel;
        componentInstance.content = options.content;
        componentInstance.buttonLabel = options.buttonLabel;
    }
}
